import BaseAdsDirections from './BaseAdsDirections';

export default BaseAdsDirections;
